import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

//トップページ
export function homeFunc() {
  const mvSwiper = new Swiper('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    effect: 'slide',
    speed: 700,
    centeredSlides : true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
    },
    slidesPerView: 1,
    spaceBetween: 0,
  });
}
